import React, { CSSProperties, useState } from "react";
import styles from "./classes.module.scss";
import cs from "classnames";
import { ReactComponent as OpenedEyeIcon } from "../../SVGcomponents/open-eye-icon.svg";
import { ReactComponent as ClosedEyeIcon } from "../../SVGcomponents/closed-eye-icon.svg";

export type BasicInputProps = {
  type: React.HTMLInputTypeAttribute;
  placeholder: string;
  label?: string;
  onChange?: (e: React.SyntheticEvent) => void;
  error?: boolean;
  AdditionalInfoComponent?: JSX.Element;
  value?: string;
  registerData?: any;
  sx?: CSSProperties;
  cls?: string;
  LeftIcon?: any;
  name?: string;
  wrapperCls?: any;
  ref?: any;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  registerOptions?: any;
};

const BasicInput = ({
  type,
  onChange,
  value,
  placeholder,
  error,
  LeftIcon,
  sx,
  name,
  registerData,
  cls,
  wrapperCls,
  ref,
  onBlur,
  registerOptions,
}: BasicInputProps) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  const regProps =
    registerData &&
    registerData(name, {
      required: "this field is required",
      ...registerOptions,
    });

  return (
    <div ref={ref} className={cs(styles.wrapper, wrapperCls && wrapperCls)}>
      {LeftIcon && <LeftIcon />}
      <input
        placeholder={placeholder}
        style={{ ...sx }}
        type={type === "password" && !isPasswordVisible ? "password" : "text"}
        value={value}
        name={name}
        onChange={onChange && onChange}
        className={cs(styles.input, cls, {
          [styles.error]: error,
        })}
        onBlur={onBlur}
        {...(registerData && regProps)}
      />
      {type === "password" && (
        <div className={styles["eye-icon"]} onClick={togglePasswordVisibility}>
          {!isPasswordVisible ? <OpenedEyeIcon /> : <ClosedEyeIcon />}
        </div>
      )}
    </div>
  );
};

export const Input = ({
  type,
  onChange,
  placeholder,
  AdditionalInfoComponent,
  value,
  sx,
  registerData,
  error,
  name,
  registerOptions,
}: BasicInputProps) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  return (
    <>
      <div className={styles["wrapper"]}>
        <input
          style={{ ...sx }}
          value={value}
          placeholder={placeholder}
          type={type === "password" && !isPasswordVisible ? "password" : "text"}
          onChange={onChange && onChange}
          className={cs(styles.input, {
            [styles.error]: error,
          })}
          {...(registerData &&
            registerData(
              name || placeholder?.toLowerCase(),
              registerOptions || { required: true },
            ))}
        />

        {type === "password" && (
          <div
            className={styles["eye-icon"]}
            onClick={togglePasswordVisibility}
          >
            {!isPasswordVisible ? <OpenedEyeIcon /> : <ClosedEyeIcon />}
          </div>
        )}
      </div>
      {AdditionalInfoComponent && AdditionalInfoComponent}
    </>
  );
};

export default BasicInput;
